import FrequencyTitle from "./FrequencyTitle";

export default FrequencyTitle;
